import {useRouter} from 'vue-router'
import {useLocalRoute} from '@toolify/client/src/modules/routes/composables/useLocalRoute'
import {useActivityItemSocketListener} from '@toolify/client/src/composables/useActivityItemSocketListener'
import {ActivityItemType} from '@toolify/server/src/models/mongoose/ActivityItemModel/enum/ActivityItemType'
import {mapWorkspaceResponseInstance} from '@toolify/client/src/modules/api/singletons/mapWorkspaceResponseInstance'
import {useWorkspaceStore} from '@toolify/client/src/stores/WorkspaceStore/useWorkspaceStore'
import {LocalPreferenceType} from '@toolify/client/src/stores/LocalPreferenceStore/enum/LocalPreferenceType'
import {useLocalPreferenceStore} from '@toolify/client/src/stores/LocalPreferenceStore/useLocalPreferenceStore'

export function useWorkspaceSocketHooks() {
  const workspaceStore = useWorkspaceStore()
  const route = useLocalRoute()
  const router = useRouter()
  const localPreferenceStore = useLocalPreferenceStore()

  useActivityItemSocketListener(ActivityItemType.WorkspaceUpdated, ({payload, targetResource}) => {
    const foundWorkspace = workspaceStore.myWorkspaces?.find(workspace => workspace.id === targetResource.resourceId)
    if(foundWorkspace) {
      workspaceStore.myWorkspaces = workspaceStore.myWorkspaces.map(workspace => {
        if(workspace.id !== targetResource.resourceId) {
          return workspace
        }
        return mapWorkspaceResponseInstance(payload.currentWorkspace)
      })
    }
    if(workspaceStore.currentWorkspace && workspaceStore.currentWorkspace.id === targetResource.resourceId) {
      workspaceStore.currentWorkspace = mapWorkspaceResponseInstance(payload.currentWorkspace)
      void localPreferenceStore.set(LocalPreferenceType.LastWorkspaceName, payload.currentWorkspace.name)
      if(payload.previousWorkspace.name !== payload.currentWorkspace.name) {
        router.push({
          name: route.value.name,
          params: {
            ...route.value.params,
            workspaceName: payload.currentWorkspace.name,
          },
        })
      }

    }
  })
}
